import { TuiCountryIsoCode } from "@taiga-ui/i18n";
import { VehicleChassisTypeEnum } from "src/app/enum/vehicle-chassis-type.enum";
import { VehicleFuelTypeEnum } from "src/app/enum/vehicle-fuel.enum";
import { DocumentType } from 'src/app/enum/document-type.enum';
import { Client } from "src/app/models/service-detail/service-detail.model";
import { Zone } from "src/app/models/zone/zone.model";


export type HourType = 'Franja horaria' | 'Hora fija';

export enum ModalMode {
  Add = 'ad',
  Edit = 'ed',
  Duplicate = 'du',
}

export type AutoKey = 'origin' | 'destination' | 'tyres' | 'provider';

export interface CustomTyre {
  tyreSeason: 'verano' | 'invierno' | '4estaciones' | null;
  withStuds: boolean;
  exchangeOld: boolean;
  tyreWidth: string;
  tyreSeries: string;
  tyreDiameter: string;
  tyreLoadIndex: string;
  tyreSpeedIndex: string;
  tyreBrand: string;
  tyreModel: string;
  tyreCount: number;
  tyreUnitCost: number | string;
  serviceOption:
    | 'movilidad'
    | 'sin-movilidad'
    | 'envio'
    | 'montaje-domicilio'
    | null;
  needAlignment: boolean;
}

export interface ServiceForm {
  /* ──────────────── CABECERA ──────────────── */
  zone: Zone | null;
  clientName: Client | null;

  /* ────────────── FECHA / HORA ────────────── */
  serviceStartDate: string;
  singleTime: HourType | null; 
  serviceStartHour: string; 
  workdayStartTime: string; 
  workdayEndTime: string; 

  /* ───────────────── VEHÍCULO ─────────────── */
  vehicleTypeName: VehicleChassisTypeEnum | null;
  vehicleBrand: string;
  vehicleModel: string;
  licensePlate: string;
  vehicleFuelName: VehicleFuelTypeEnum | null;

  /* ───────────── DIRECCIONES GENÉRICAS ────── */
  originAddress: string;
  originAddressDetails: string;
  originAddressGeopointLt: number;
  originAddressGeopointLn: number;

  destinationAddress: string;
  destinationAddressDetails: string;
  destinationAddressGeopointLt: number;
  destinationAddressGeopointLn: number;

  sameOriginAddress: boolean;

  providerAddress: string;
  providerAddressGeopointLt: number;
  providerAddressGeopointLn: number;

  originAddressPlaceId: string | null;
  destinationAddressPlaceId: string | null;

  tyresAddress: string;
  tyresAddressGeopointLt: number;
  tyresAddressGeopointLn: number;

  /* ───────────────── CONTACTOS ─────────────── */
  isOriginContactExternal: boolean;
  originContactName: string;
  originContactPhoneNumber: string;
  originalContactPhoneNumberPhoneIso: TuiCountryIsoCode;

  originContactEmailAddress: string;

  sameContactOriginDestiny: boolean;

  isDestinationContactExternal: boolean;
  destinationContactName: string;
  destinationContactPhoneNumber: string;
  destinationContactPhoneIso: TuiCountryIsoCode;
  destinationContactEmailAddress: string;

  vertical: string | null;
  product: string | null;
  provider: string | null;
  comments: string;
  deliveryNoteId: string;

  orderType: number; 
  extras: CustomTyre[]; 
  aditionalTyresInfo: boolean;

  vehicleFuelType: string;
  monetaryAmount: string;

  vehicleStatus: string ;
  appointmentCode: string;
  isInspectionPaid: boolean;
  appointmentDate: string;
  appointmentHour: string;

  /* —— NEUMÁTICOS (TYRES) ———————————————— */
  tyreOrderType: '4iguales' | '2x2' | 'custom' | null;
  tyreSeason: 'verano' | 'invierno' | '4estaciones' | null;
  withStuds: boolean;
  exchangeOld: boolean;
  tyreWidth: string;
  tyreSeries: string;
  tyreDiameter: string;
  tyreLoadIndex: string | number;
  tyreSpeedIndex: string;
  tyreBrand: string;
  tyreModel: string;
  tyreCount: number;
  tyreUnitCost: number | string;
  serviceOption:
    | 'movilidad'
    | 'sin-movilidad'
    | 'envio'
    | 'montaje-domicilio'
    | null;
  needAlignment: boolean;
  originContactDocumentType?: DocumentType;
  originContactDocumentNumber?: string;
  destinationContactDocumentType?: DocumentType;
  destinationContactDocumentNumber?: string;

  customProductPrice: number | null;
  customCaflerFee: number | null;
  addFixedFee: boolean;
  addUrgencyFee: boolean;
  isPoolService: boolean;
  customPoolPrice: number | null;
}